module.exports = __webpack_public_path__ + "img/EU-flag.c6564118.png";